<mat-spinner class="spinner" [diameter]="size" [strokeWidth]="stroke" [style.--loader-color]="color"></mat-spinner>
